import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

import type { Order } from '@/types/order.type.ts';

type OrderStore = {
  order: Order | null;
};

export const useOrderStore = create<OrderStore>()(
  devtools(
    persist<OrderStore>(
      () => ({
        order: null,
      }),
      {
        name: 'order-storage',
        storage: createJSONStorage(() => sessionStorage),
      }
    ),
    {
      name: 'Order',
      enabled: import.meta.env.MODE !== 'test',
    }
  )
);
